// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill';
import Vue from 'vue';
import App from './App';
import router from './router';
import VueI18n from 'vue-i18n';
import {extend, ValidationProvider, ValidationObserver} from 'vee-validate';
import {required, email} from 'vee-validate/dist/rules';
// 【Custom Plugins】
// Import Cognito Plugins..
import Cognito from './custom_plugins/auth/cognito';
import InvokeUrlMaker from './custom_plugins/invoke/url_maker';
import CustomEnv from './custom_plugins/env/custom_env';
// 【Constants】
import texts from '../common/src/constrains/locale/texts';
import vuetify from './plugins/vuetify';
import {parsePhoneNumberFromString} from 'libphonenumber-js';

// Vue.use(datePicker);
Vue.use(VueI18n);
// Create VueI18n instance with options
const i18n = new VueI18n({
    locale: 'ja',
    messages: texts
});
extend('required', required);
extend('email', email);
extend('tel', {
    validate: function (value) {
        let phoneNumber = parsePhoneNumberFromString(value, 'JP');
        if (!phoneNumber) {
            return false;
        }
        return phoneNumber.isValid();
    }
});
extend('katakana', {
    validate: function (value) {
        return /^([ァ-ヴ]|[ァ-ヴー・]|[ｦ-ﾟ]|[ 　])*$/.test(value)
    }
});
extend('zip1', {
    validate: function (value) {
        return /^[0-9０-９]{3}$/.test(value)
    }
});
extend('zip2', {
    validate: function (value) {
        return /^[0-9０-９]{4}$/.test(value)
    }
});
extend('officeNo', {
    validate: function (value) {
        return /^[0-9０-９a-zA-Zａ-ｚＡ-Ｚ]{10}$/.test(value)
    }
});
extend('companyNo', {
    validate: function (value) {
        return /^[0-9０-９]{13}$/.test(value)
    }
});
Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
// 【Custom Plugin】
// Cognito Set up..
Vue.use(Cognito, process.env);
// Url Maker Set up...
Vue.use(InvokeUrlMaker, process.env);
// CustomEnv Set UP...
Vue.use(CustomEnv, process.env);

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
    el: '#app',
    i18n: i18n,
    router,
    Cognito,
    components: {App},
    vuetify,
    template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js